module.exports = __webpack_public_path__ + "static/gallery24-ee35fcdde7ca8a0d515a3e86c7186177.jpg";